import gql from "graphql-tag";
export default gql`
  mutation ResendTestAdmin($input: ResendTestAdminInput!) {
    resendTestAdmin(input: $input)
  }
`;
export interface ResendTestAdminMutation {
  resendTestAdmin: boolean | null;
}
